// extracted by mini-css-extract-plugin
export default {"icons":"Socials_icons__ud-Lv","iconsLink":"Socials_iconsLink__+L5H0"};